import { Divider, Stack, Typography } from "@mui/material";

export const NotFoundPage = () => {
  return (
    <Stack
      data-testid="not-found-page"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "calc(100vh - 120px)",
        px: 3,
        py: 4,
      }}
      spacing={1}
    >
      <Typography variant="h4" gutterBottom>
        Are you lost?
      </Typography>
      <Typography variant="h6">The page you are looking for does not exist... yet 😉</Typography>
      <Divider sx={{ width: "100%", maxWidth: 400, my: 2 }} />
      <Typography variant="subtitle2" color="text.secondary">
        Definetly something we should add a test for on our side...
      </Typography>
    </Stack>
  );
};
